<div class="accept-terms-container" [ngClass]="{'terms-not-accepted' : !termsAccepted}">
  <div [ngClass]="{'m-5' : !termsAccepted }">
    @if (!termsAccepted) {
      <h5>
        {{'TERMS.ACCEPTNEWTERMS' | translate}}
      </h5>
    }
    <div class="accept-terms-content">
      <div class="view-terms-container" [ngClass]="{'terms-not-accepted' : !termsAccepted}">
        @if (!termsAccepted) {
          <div class="mr-3">
            {{'TERMS.ACCEPTTERMSBEFOREDELIVERY' | translate}}
          </div>
        }
        @if (termsAccepted) {
          <div class="mr-3">
            {{ 'TERMS.TERMSALREADYACCEPTED' | translate}}
          </div>
        }
        <button class="btn btn-secondary view-terms-btn" (click)="viewTerms()">
          @if (!termsAccepted) {
            <span>{{'TERMS.VIEWTERMS' | translate}}</span>
          }
          @if (termsAccepted) {
            <span>{{'TERMS.VIEWTERMSACCEPTED' | translate}}</span>
          }
        </button>
      </div>
      @if (!termsAccepted) {
        <hr class="divider">
        <div class="accept-terms-button">
          <button class="btn btn-cta" (click)="setAcceptTerms()" [disabled]="!termsViewed || termsAccepted">
            {{ 'TERMS.ACCEPTTERMSBUTTON' | translate}}
          </button>
        </div>
      }
    </div>
  </div>
</div>